<template>
  <div class="content">
    <div class="inner_content">
      <div class="header">
        <div class="flex">
          <div
            class="box flex"
            style="align-items:center"
            v-if="!$route.query.couponId"
          >
            <div class="title">券名称：</div>
            <el-select
              v-model="coupon_id"
              placeholder="请选择"
              size="small"
              class="fixedwidth"
              clearable
            >
              <el-option
                v-for="item in couponListArr"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="box flex" style="align-items:center">
            <div class="title">手机号：</div>
            <el-input
              style="width: 180px"
              size="small"
              v-model="mobile"
            ></el-input>
          </div>
          <div class="box flex" style="align-items:center">
            <div class="title">是否剩余：</div>
            <el-select
              v-model="is_remaining"
              placeholder="请选择"
              size="small"
              class="fixedwidth"
              clearable
            >
              <el-option
                v-for="item in remainingArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex">
          <div class="box flex" style="align-items:center">
            <div class="title">是否过期：</div>
            <el-select
              v-model="is_exp"
              placeholder="请选择"
              size="small"
              class="fixedwidth"
              clearable
            >
              <el-option
                v-for="item in expOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="box flex" style="align-items:center">
            <div class="title">是否暂停：</div>
            <el-select
              v-model="is_stop"
              placeholder="请选择"
              size="small"
              class="fixedwidth"
              clearable
            >
              <el-option
                v-for="item in stopArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="box flex" style="align-items:center">
            <div class="title">领取方式：</div>
            <el-select
              v-model="get_type"
              placeholder="请选择"
              size="small"
              class="fixedwidth"
              clearable
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex">
          <div class="box flex">
            <div class="title">领取时间：</div>
            <el-date-picker
              clearable
              style="width: 160px;"
              v-model="dateValue[0]"
              type="date"
              class="date_picker_box"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
            <el-time-picker
              clearable
              style="width: 160px;"
              placeholder="时间"
              v-model="timeValue[0]"
              class="time_picker_box"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              size="small"
            ></el-time-picker>
            <span style="margin-right:8px">至</span>
            <el-date-picker
              clearable
              style="width: 160px;"
              v-model="dateValue[1]"
              type="date"
              class="date_picker_box"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
            <el-time-picker
              clearable
              style="width: 160px;"
              placeholder="时间"
              v-model="timeValue[1]"
              class="time_picker_box"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              size="small"
            ></el-time-picker>
          </div>
        </div>
        <div class="flex">
          <div class="box flex">
            <div class="title">券有效期：</div>
            <el-date-picker
              clearable
              style="width: 160px;"
              v-model="dateValue1[0]"
              type="date"
              class="date_picker_box"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
            <el-time-picker
              clearable
              style="width: 160px;"
              placeholder="时间"
              v-model="timeValue1[0]"
              class="time_picker_box"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              size="small"
            ></el-time-picker>
            <span style="margin-right:8px">至</span>
            <el-date-picker
              clearable
              style="width: 160px;"
              v-model="dateValue1[1]"
              type="date"
              class="date_picker_box"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
            <el-time-picker
              clearable
              style="width: 160px;"
              placeholder="时间"
              v-model="timeValue1[1]"
              class="time_picker_box"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              size="small"
            ></el-time-picker>
          </div>
        </div>
        <div class="flex">
          <div class="box flex">
            <el-button type="primary" size="small" @click="screen"
              >筛选</el-button
            >
            <el-button type="primary" size="small" @click="exportExcel"
              >导出</el-button
            >
            <el-button type="primary" size="small" @click="zantingpl('1')"
              >批量暂停</el-button
            >
            <el-button type="primary" size="small" @click="zantingpl('0')"
              >批量开启</el-button
            >
            <el-button type="primary" size="small" @click="zuofeipl"
              >批量作废</el-button
            >
          </div>
        </div>
      </div>
      <div style="margin-bottom: 20px;">
        <el-row :gutter="20">
          <el-col :span="6">
            <div>
              <el-statistic title="使用数量">
                <template slot="formatter">
                  <span style="color: rgb(47, 84, 235);">
                    {{ count.use_num }}
                  </span>
                </template>
                <template slot="suffix">
                  <span>张</span>
                </template>
              </el-statistic>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-statistic title="发放数量">
                <template slot="formatter">
                  <span style="color: rgb(47, 84, 235);">
                    {{ count.send_num }}
                  </span>
                </template>
                <template slot="suffix">
                  <span>张</span>
                </template>
              </el-statistic>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-statistic title="剩余数量">
                <template slot="formatter">
                  <span style="color: rgb(47, 84, 235);">
                    {{ count.num }}
                  </span>
                </template>
                <template slot="suffix">
                  <span>张</span>
                </template>
              </el-statistic>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-statistic title="使用率">
                <template slot="formatter">
                  <span style="color: rgb(47, 84, 235);">
                    {{ count.use_rate }}
                  </span>
                </template>
                <template slot="suffix">
                  <span>%</span>
                </template>
              </el-statistic>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- <div>
        <div>统计：</div>
        <div>
          <span>发放数量：{{ count.send_num }}</span>
          <span>使用数量：{{ count.use_num }}</span>
          <span>剩余数量：{{ count.num }}</span>
          <span>使用率：{{ count.use_rate }}</span>
        </div>
      </div> -->
      <div class="bottom">
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="multipleTable"
          size="small"
          :header-cell-style="setHeader"
          height="100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="title" label="券名称"></el-table-column>
          <el-table-column label="券类型" prop="coupon_type_name">
            <!-- <template slot-scope="scope">
              <div v-if="scope.row.coupon_type == 1">满减券</div>
              <div v-if="scope.row.coupon_type == 2">折扣券</div>
              <div v-if="scope.row.coupon_type == 3">代金券</div>
              <div v-if="scope.row.coupon_type == 4">兑换券</div>
              <div v-if="scope.row.coupon_type == 5">储值券</div>
              <div v-if="scope.row.coupon_type == 6">通用券</div>
              <div v-if="scope.row.coupon_type == 7">次数券</div>
            </template> -->
          </el-table-column>
          <el-table-column prop="send_num" label="领取数量"></el-table-column>
          <el-table-column prop="num" label="剩余数量"></el-table-column>

          <el-table-column prop="real_name" label="会员名"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="source" label="来源"></el-table-column>
          <el-table-column prop="get_time" label="领取时间"></el-table-column>
          <el-table-column prop="exp_state" label="是否过期"></el-table-column>
          <el-table-column prop="start_time" label="开始时间"></el-table-column>
          <el-table-column prop="end_time" label="结束时间"></el-table-column>
          <el-table-column
            prop="cancel_time"
            label="作废时间"
          ></el-table-column>
          <el-table-column prop="stop_state" label="暂停状态"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="zanting(scope.row)">{{
                scope.row.is_stop == 0 ? "暂停用券" : "开启用券"
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next"
          :total="total_num"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { exportMethod } from "@/api/vip";
import {
  couponVerifiy,
  coupon_receive_index,
  couponShop,
  couponCancle_expser,
  couponList,
} from "@/api/coupon";
export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  data() {
    return {
      loading: false,
      is_used: "1", //使用状态
      is_cancle: "", //核销状态 0 用户使用 1 扫码核销
      get_type: "", //领取方式
      page: "1",
      total_num: 0,
      tableData: [],
      formLabelWidth: "120px",
      dialogFormVisible: false,
      options: [
        {
          value: "0",
          label: "用户使用",
        },
        {
          value: "1",
          label: "扫码核销",
        },
      ],
      expOptions: [
        {
          value: "0",
          label: "未过期",
        },
        {
          value: "1",
          label: "已过期",
        },
      ],
      stopArr: [
        {
          value: "0",
          label: "未暂停",
        },
        {
          value: "1",
          label: "已暂停",
        },
      ],
      remainingArr: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      typeOptions: [
        {
          value: "0",
          label: "发放",
        },
        {
          value: "1",
          label: "领取",
        },
        {
          value: "2",
          label: "赠送",
        },
      ],
      is_exp: "",
      is_stop: "",
      is_remaining: "",
      mobile: "",
      coupon_id: "",
      value1: "",
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000",
      },
      dateValue: [],
      timeValue: [],
      dateValue1: [],
      timeValue1: [],
      couponListArr: [],
      count: {},
      multipleSelection: [],
      coupon_ids: "",
    };
  },
  mounted() {
    if (this.$route.query.couponId) {
      this.coupon_id = this.$route.query.couponId;
    }
    this.getLists();
    this.getCouponList();
  },
  methods: {
    zantingpl(is_stop) {
      if (this.multipleSelection.length == 0) {
        return this.$message({
          type: "warning",
          message: "请选择数据",
        });
      }
      let data = {
        token: this.token,
        app_id: this.app_id,
        coupon_ids: this.coupon_ids,
        is_stop,
        type: "0",
      };
      couponShop(data).then((res) => {
        console.log("sss", res);

        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getLists();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    exportExcel() {
      if (this.dateValue.length > 1) {
        let a = new Date(this.dateValue[0]).getTime();
        let b = new Date(this.dateValue[1]).getTime();
        let c = b - a;
        if (Math.floor(c / 86400000) > 31) {
          this.$message("领取开始时间与结束时间,间隔不能超过一个月");
        } else {
          var data = {
            token: this.token,
            Api: "coupon/agent.coupon_data/coupon_receive_index",
            params: [
              { name: "app_id", value: this.app_id },
              { name: "export_", value: "1" },
              { name: "get_type", value: this.get_type },
              { name: "is_exp", value: this.is_exp },
              { name: "mobile", value: this.mobile },
              { name: "coupon_id", value: this.coupon_id },
              { name: "is_stop", value: this.is_stop },
              { name: "is_remaining", value: this.is_remaining },
              { name: "get_time_s", value: this.dateValue[0] },
              { name: "get_time_e", value: this.dateValue[1] },
            ],
          };
          console.log(data);
          exportMethod(data);
        }
      } else {
        this.$message("请选择领取时间");
      }
    },
    zuofeipl() {
      if (this.multipleSelection.length == 0) {
        return this.$message({
          type: "warning",
          message: "请选择数据",
        });
      }
      couponCancle_expser({
        token: this.token,
        app_id: this.app_id,
        coupon_id: this.coupon_ids,
        type: "0",
      }).then((res) => {
        console.log("sss", res);
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getLists();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    handleSelectionChange(val) {
      console.log("val", val);
      this.multipleSelection = val;
      let arr = [];
      this.multipleSelection.forEach((item) => {
        arr.push(item.coupon_id);
      });
      this.coupon_ids = arr.join(",");
      console.log("coupon_ids", this.coupon_ids);
    },
    zanting(row) {
      let arr = [];
      if (row.is_stop == 0) {
        arr.push(row.coupon_id);
      }
      this.$confirm("确认暂停该券吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {
          token: this.token,
          app_id: this.app_id,
          coupon_ids: arr.join(","),
          is_stop: row.is_stop == 0 ? "1" : "0",
          type: "0",
        };
        couponShop(data).then((res) => {
          console.log("sss", res);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getLists();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      });
    },
    getCouponList() {
      couponList({ app_id: this.app_id, num: 9999, page: 1 }).then((res) => {
        this.couponListArr = res.data.result;
      });
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    addSlice() {
      this.$router.push({
        path: `adSign`,
      });
    },
    // 筛选page
    screen() {
      this.page = 1;
      // if (
      //   this.dateValue.length > 1 &&
      //   new Date(this.dateValue[0]).getTime() >
      //     new Date(this.dateValue[1]).getTime()
      // ) {
      //   this.$message("开始时间不能大于结束时间");
      // } else {
      this.getLists();
      // }
    },
    // 核销记录
    getLists() {
      this.loading = true;
      let data = {
        token: this.token,
        app_id: this.app_id,
        get_type: this.get_type,
        is_exp: this.is_exp,
        mobile: this.mobile,
        page: this.page,
        coupon_id: this.coupon_id,
        is_stop: this.is_stop,
        is_remaining: this.is_remaining,
        count_data: "1",
        limit: "10",
      };
      if (this.dateValue !== null && this.dateValue.length !== 0) {
        if (this.dateValue[0] != null) {
          data.get_time_s = this.timeValue[0]
            ? this.dateValue[0] + " " + this.timeValue[0]
            : this.dateValue[0] + " 00:00:00";
          data.get_time_e = this.timeValue[1]
            ? this.dateValue[1] + " " + this.timeValue[1]
            : this.dateValue[1] + " 23:59:59";
        }
      }
      if (this.dateValue1 !== null && this.dateValue1.length !== 0) {
        if (this.dateValue1[0] != null) {
          data.start_time = this.timeValue1[0]
            ? this.dateValue1[0] + " " + this.timeValue1[0]
            : this.dateValue1[0] + " 00:00:00";
          data.end_time = this.timeValue1[1]
            ? this.dateValue1[1] + " " + this.timeValue1[1]
            : this.dateValue1[1] + " 23:59:59";
        }
      }
      coupon_receive_index(data).then((res) => {
        console.log("sss", res);
        this.loading = false;
        if (res.code == 200) {
          this.tableData = res.data.result;
          this.total_num = res.data.total_num;
          this.count = res.data.count;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.page = val;
      this.getLists();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getLists();
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  overflow: auto;
  min-width: 900px;
  border: node;
  // background: rgba(240, 242, 245, 1);
  .inner_content {
    background: #fff;
    padding: 0 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .header {
      padding-top: 20px;
      margin-bottom: 20px;
      .box {
        // width: 330px;
        .title {
          min-width: 100px;
          text-align: right;
        }
        .fixedwidth {
          width: 180px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .bottom {
      flex: 1;
      overflow-y: scroll;
    }
    .page {
      height: 50px;
      display: flex;
      align-items: center;
    }
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 3px 0px;
}
.el-table td {
  // padding: 12px 0;
}
::v-deep.el-statistic .con{
  align-items: baseline !important;
}
</style>
